import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import NavButton from "components/NavButton";
import { requestFindTreatmentSites } from 'modules/treatmentSite/actions';
import Sidebar from "components/Sidebar"
import {
  Header,
  TablePlaceHolder
} from './components/SearchComponents';
import TreatmentSiteTableItem from './components/TreatmentSiteTableItem';
import SearchBar from 'view/components/SearchBar';

const initialPageSize = 50;
const pageSize = 20;
const bottomLoadHeight = 1200;

class TreatmentSite extends Component {
  constructor() {
    super();
    this.state = {
      redirectTo: '',
      treatmentSitesLoaded: false,
      stages: [],
      searchText: '',
      sortField: 'name',
      sortDirection: 1,
    };
  }

  componentWillMount = () => {
    console.log('component mounting');
    if (this.props.treatmentSites.length > 0) {
      this.setState({ treatmentSitesLoaded: true});
      return;
    }

    this.props.requestFindTreatmentSites({
      query: {
        limit: initialPageSize,
        skip: 0,
        stages: [],
        search: '',
        sortField: 'name',
        sortDirection: 1,
      },
      callback: () => this.setState({ treatmentSitesLoaded: true }),
    });
  }

  redirect = (to) => this.props.history.push(to);

  render() {
    const treatmentSites = this.props.treatmentSites.list;
    const LengthToAdd = treatmentSites.list ? (treatmentSites.total - treatmentSites.list.length) * 70 : 0;

    return (
      <main className="dashboard content-page" onScroll={this.onScroll}>
        <Sidebar />
        <div className="content">
          {/* <h1>Health Care Professionals</h1> */}
          <div className='search-container'>
            <div className="search-bar">
              <SearchBar
                tabIndex={200}
                width='187px'
                placeholder='Search...'
                msDebounce={300}
                onChange={async searchText => {
                  await this.setState({ searchText });
                  this.filterResults();
                }}
              />
            </div>

            <NavButton className="button-type-1" to='/treatment/create' style={{ marginRight: '40px', float: 'right' }}>+ Add Account</NavButton>

            <TreatmentSiteTable>
              <Header />
              <div className='table-contents hcps'>
                <div style={{width: '100%', display:'table'}}>
                  {treatmentSites.list && treatmentSites.list.length > 0 ? treatmentSites.list.map((treatmentSite, index) => (
                    
                    <TreatmentSiteTableItem
                      onClick={exclude(['a', 'button'], () => this.redirect(`/treatment/update?id=${treatmentSite.id}`))}
                      tabIndex={300 + index}
                      key={index}
                      treatmentSite={treatmentSite}
                    />
                  )) : (
                    <TablePlaceHolder />
                  )}
                  <div style={{height: `${LengthToAdd}px`}}></div>
                </div>

              </div>
            </TreatmentSiteTable>
          </div>
        </div>
      </main>
    )
  }

  onScroll = async e => {
    const treatmentSites = this.props.treatmentSites.list;
    const { treatmentSitesLoaded } = this.state;
    if (treatmentSites.listComplete) return;

    const currentFilledLength = treatmentSites.list.length * 70; 
    const scrollPosition = e.target.offsetHeight + e.target.scrollTop;
    
    if (scrollPosition < currentFilledLength - bottomLoadHeight) return;
    
    if (treatmentSitesLoaded) { //i.e. no currently pending calls to the DB
      this.setState({ treatmentSitesLoaded: false });
      const { searchText, sortField, sortDirection, stages } = this.state;
      
      //if user scrolls past currently loaded point increase page size to load to that point in only one call
      let limit = pageSize;
      if (((scrollPosition / 70) - treatmentSites.list.length) > pageSize) 
        limit = ((scrollPosition / 70) - treatmentSites.list.length) + 10; // + 10 to account for extra scrolling during load
      
      this.props.requestFindTreatmentSites({
        query: {
          limit,
          skip: treatmentSites.list.length,
          stages,
          search: searchText,
          sortField,
          sortDirection,
        },
        callback: () => {
          this.setState({ treatmentSitesLoaded: true });
        }});  
    }
    
  }

  async filterResults() {
    const {searchText, stages, sortDirection, sortField} = this.state;
    this.props.requestFindTreatmentSites({
      query: {
        limit: initialPageSize,
        skip: 0,
        stages,
        search: searchText,
        sortField,
        sortDirection,
      },
    });
  }
}

const exclude = (exclusions, fn) => event => {
  if (!event.target.matches(exclusions)) {
    fn(event);
  }
};

const nullCheckedIncludes = (string, filter) =>
  string && string.toLowerCase().includes(filter.toLowerCase());

const excludeLinks = (event, fn) => {
  if (!event.target.matches('a')) {
    fn(event);
  }
}

const mapStateToProps = ({ treatmentSites }) => ({ treatmentSites });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { requestFindTreatmentSites },
    dispatch
  );

const TreatmentSiteTable = (props) => (
  <div className='default-table' {...props}>
  </div>
);

export const HeadRow = (props) => (
  <div className='table-head-row' {...props}>
  </div> 
);

export const Row = (props) => (
  <div className='table-row' {...props}>
  </div>
);

export const Cell = ({width, ...props}) => (
  <div className='table-cell' {...props} style={{width}}>
  </div>
);

const PlaceHolderRow = index => (
  <Row key={index}>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
  </Row>
);  

export default connect(mapStateToProps, mapDispatchToProps)(TreatmentSite);